import { combineReducers } from "redux";
import {
  CHANGE_HEALTH_TAG_WEIGHT_REQUEST,
  CREATE_HEALTH_TAG_REQUEST,
  FETCH_HEALTH_TAGS_REQUEST,
  UPDATE_HEALTH_TAG_REQUEST,
  DELETE_HEALTH_TAG_REQUEST,
} from "./constants";
import { CREATE_DOCTOR_HEALTH_TAG_REQUEST } from "../doctor/constants";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Action } from "./types";
import { Action as DoctorAction } from "../doctor/types";
import { HealthTag } from "../types";

function items(state: HealthTag[] = [], action: Action): HealthTag[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_HEALTH_TAGS_REQUEST):
      return action.payload;

    case UPDATE_HEALTH_TAG_REQUEST:
    case CHANGE_HEALTH_TAG_WEIGHT_REQUEST:
      return state.map((healthTag) =>
        healthTag.id === action.data.healthTagId ? { ...healthTag, isFetching: true } : healthTag
      );

    case getSuccessActionType(UPDATE_HEALTH_TAG_REQUEST):
    case getSuccessActionType(CHANGE_HEALTH_TAG_WEIGHT_REQUEST):
      return state.map((healthTag) =>
        healthTag.id === action.data.healthTagId ? { ...action.payload, isFetching: false } : healthTag
      );

    case getFailureActionType(UPDATE_HEALTH_TAG_REQUEST):
    case getFailureActionType(CHANGE_HEALTH_TAG_WEIGHT_REQUEST):
      return state.map((healthTag) =>
        healthTag.id === action.data.healthTagId ? { ...healthTag, isFetching: false } : healthTag
      );

    case getSuccessActionType(DELETE_HEALTH_TAG_REQUEST):
      return state?.filter((healthTag) => healthTag.id !== action.data.healthTagId);

    case getSuccessActionType(CREATE_HEALTH_TAG_REQUEST):
      return [...state, action.payload];
    default:
      return state;
  }
}

function isFetching(state = false, action: Action | DoctorAction) {
  switch (action.type) {
    case FETCH_HEALTH_TAGS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_HEALTH_TAGS_REQUEST):
    case getFailureActionType(FETCH_HEALTH_TAGS_REQUEST):
      return false;

    case CREATE_HEALTH_TAG_REQUEST:
      return true;
    case getSuccessActionType(CREATE_HEALTH_TAG_REQUEST):
    case getFailureActionType(CREATE_HEALTH_TAG_REQUEST):
      return false;

    case CREATE_DOCTOR_HEALTH_TAG_REQUEST:
      return true;
    case getSuccessActionType(CREATE_DOCTOR_HEALTH_TAG_REQUEST):
    case getFailureActionType(CREATE_DOCTOR_HEALTH_TAG_REQUEST):
      return false;
    default:
      return state;
  }
}

export const healthTags = combineReducers({ items, isFetching });
